import axios from 'axios';
import config from '@/config';
import { retryCallback } from '@/libs/retry-utils';



class Service {
  constructor() {
    let service = axios.create();
    this.service = service;
  }
  
  get(path, callback) {
    const requestFn = (wrappedCallback) => {
      return this.service.get(config.apiV2.url + path).then(
        (response) => wrappedCallback(null, response.data)).catch(function(error) {
          if (error.response) {
                // that falls out of the range of 2xx
                wrappedCallback(error.response, null)
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
                wrappedCallback(error.request, null)
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                wrappedCallback(error.message, null)
              }
        });
    };

    retryCallback(requestFn, callback);
  }

  delete(path, callback) {
    const requestFn = (wrappedCallback) => {
      return this.service.delete(config.apiV2.url + path).then(
        (response) => wrappedCallback(null, response.data)).catch(function(error) {
          if (error.response) {
                // that falls out of the range of 2xx
                wrappedCallback(error.response, null)
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
                wrappedCallback(error.request, null)
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                wrappedCallback(error.message, null)
              }
        });
    };

    retryCallback(requestFn, callback);
  }

  put(path, payload, callback) {
    const requestFn = (wrappedCallback) => {
      return this.service.request({
        method: 'PUT',
        url: config.apiV2.url + path,
        responseType: 'json',
        data: payload
      }).then((response) => wrappedCallback(null, response.data)).catch(function(error) {
          if (error.response) {
                // that falls out of the range of 2xx
                wrappedCallback(error.response, null)
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
                wrappedCallback(error.request, null)
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                wrappedCallback(error.message, null)
              }
        });
    };

    retryCallback(requestFn, callback);
  }

  post(path, payload, callback) {
    const requestFn = (wrappedCallback) => {
      return this.service.request({
        method: 'POST',
        url: config.apiV2.url + path,
        responseType: 'json',
        data: payload
      }).then((response) => wrappedCallback(null, response.data)).catch(function(error) {
          if (error.response) {
                // that falls out of the range of 2xx
                wrappedCallback(error.response, null)
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
                wrappedCallback(error.request, null)
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error Last', error);
                wrappedCallback(error.message, null)
              }
        });
    };

    retryCallback(requestFn, callback);
  }

  postHeader(path, payload, callback) {
    const requestFn = (wrappedCallback) => {
      return this.service.request({
        method: 'POST',
        url: config.apiV2.url + path,
        responseType: 'json',
        data: payload
      }).then((response) => wrappedCallback(null, response)).catch(function(error) {
          if (error.response) {
                // that falls out of the range of 2xx
                wrappedCallback(error.response, null)
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
                wrappedCallback(error.request, null)
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error Last', error);
                wrappedCallback(error.message, null)
              }
        });
    };

    retryCallback(requestFn, callback);
  }

  postNgrok(path, payload, callback) {
    const requestFn = (wrappedCallback) => {
      return this.service.request({
        method: 'POST',
        url:  path,
        responseType: 'json',
        data: payload
      }).then((response) => wrappedCallback(null, response.data)).catch(function(error) {
          if (error.response) {
                // that falls out of the range of 2xx
                wrappedCallback(error.response, null)
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
                wrappedCallback(error.request, null)
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error Last', error);
                wrappedCallback(error.message, null)
              }
        });
    };

    retryCallback(requestFn, callback);
  }
}

export default new Service;
